import React, { Component } from 'react'
import Title from '../../components/typography/title.component'
import styled from 'styled-components'
import { topics } from './services/faq.service'
import { connect } from 'react-redux'
import { Accordion } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { Container, ImageContainer } from './faq.page.styles'

const SideImageFaq = '../../../assets/images/faq/side-image-faq.png'

const StyledFaq = styled.div`
	display: flex;
	padding: 3rem 0px 4.6rem;
	justify-content: center;
	width: 100%;

	.ui.styled.accordion > .title:first-child {
		margin-top: 0;
	}

	.ui.styled.accordion,
	.ui.styled.accordion .accordion {
		box-shadow: none;
		width: 100%;
		max-width: 730px;
		background: transparent !important;
	}

	.ui.styled.accordion .title {
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1), 0 8px 16px rgba(0, 0, 0, 0.1);
		border: none;
		background-color: #fff;
		color: #818181;
		font-weight: bold;
		border-radius: 50px;
		display: flex;
		font-size: 1.8rem;
		text-align: left;
		justify-content: flex-start;
		margin: 20px 0px;
		padding: 15px;
		align-items: center;
	}

	.ui.styled.accordion .active.title {
		color: #272727;
		font-size: 1.8rem;
		position: relative;
		background: #fff;
	}

	.ui.accordion .active.content {
		padding-left: 1em;
		background-color: #f2f2f2;
		border-radius: 20px;
		color: #000000;
		font-size: 18px;
		font-weight: 500;
	}

	.ui.styled.accordion .title:hover {
		color: #272727;
		background: #fff;
	}

	.ui.accordion .accordion {
		margin: 0;
		padding: 0;
	}

	.ui.styled.accordion .content {
		margin: 10px 20px;
		padding: 0;
	}
`

class FaqPage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			faqTopics: []
		}
		this.getFaqTopics()
	}

	componentDidMount() {
		const { hideLoading } = this.props
		hideLoading()
	}

	render() {
		const faqTopics = this.state.faqTopics

		return (
			<Container>
				<Title>
					<span className="bold">Perguntas Frequentes</span>
				</Title>
				<StyledFaq>
					<ImageContainer>
						<img src={SideImageFaq} alt="FAQ" style={{ width: '100%' }} />
					</ImageContainer>
					<Accordion
						defaultActiveIndex={0}
						panels={this.rootPanels(faqTopics)}
						styled
					/>
				</StyledFaq>
			</Container>
		)
	}

	faqContent = faqItems => {
		let items = faqItems.map((faq, key) => {
			return {
				key: key,
				title: faq.question,
				content: ReactHtmlParser(faq.answer)
			}
		})

		return (
			<div>
				<Accordion.Accordion panels={items} />
			</div>
		)
	}

	childContent = childItems => {
		let items = childItems.map((child, key) => {
			if (child.faqItems.length > 0) {
				return {
					key: key,
					title: child.title,
					content: { content: this.faqContent(child.faqItems) }
				}
			}

			if (child.childs.length > 0)
				return {
					key: key,
					title: child.title,
					content: { content: this.childContent(child.childs) }
				}
		})

		return (
			<div>
				<Accordion.Accordion panels={items} />
			</div>
		)
	}

	rootPanels = (faq = []) => {
		let items = faq.map((topic, key) => {
			if (topic.childs.length > 0)
				return {
					key: key,
					title: topic.title,
					content: { content: this.childContent(topic.childs) }
				}

			if (topic.faqItems.length > 0)
				return {
					key: key,
					title: topic.title,
					content: { content: this.faqContent(topic.faqItems) }
				}
		})

		return items
	}

	getFaqTopics() {
		topics()
			.then(({ data: response }) => {

				if (!response.success) {
					this.props.hideLoading()
					return
				}

				this.setState({ faqTopics: response.data })
			})
			.catch(({ response }) => {
				this.props.hideLoading()
			})
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			hideLoading: SiteCreators.hideLoading
		},
		dispatch
	)

const connectedFaqPageComponent = withRouter(
	connect(null, mapDispatchToProps)(FaqPage)
)

export { connectedFaqPageComponent as ModuleRootComponent }
